import { memo } from "react";
import { STICKER_COLORS } from "@/elements/sticker";
import { HStack } from "@/shared/ui/Stack";
import styles from "./StickerColorMenu.module.css";
import { StickerColorMenuButton } from "./StickerColorMenuButton";

interface StickerColorMenuContentProps {
    selectedColors: string[];
    onColorClick: (color: string) => void;
}

export const StickerColorMenuContent = memo(function StickerColorMenuContent({
    selectedColors,
    onColorClick,
}: StickerColorMenuContentProps) {
    return (
        <HStack gap={2} wrap="wrap" className={styles.colors}>
            {STICKER_COLORS.map((color) => (
                <StickerColorMenuButton
                    key={color}
                    color={color}
                    selectedColors={selectedColors}
                    onColorClick={onColorClick}
                />
            ))}
        </HStack>
    );
});
